/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */


import { Linkable } from '@/components/blocks/Linkable';
import { useLocalization } from '@/data/Localization';
import { combineSX } from '@/utils/combineSX';
import { Stack, SxProps } from '@mui/material';
import { FC } from 'react';
import { winkelsCustServiceLinksSX } from '../styles/container';

export const HeaderUspBarRightLinks: FC<{ isMobile: boolean; sx?: SxProps }> = ({ isMobile, sx }) => {
	const RouteLocal = useLocalization('Routes');
	const HeaderLabels = useLocalization('Header');
	return (
		 isMobile &&
		<Stack sx={combineSX([winkelsCustServiceLinksSX, sx])}>
			 <Linkable id="header_usp_my_account_link" href={`/${RouteLocal.Account.route.t()}`} role="link">{HeaderLabels.Actions.MyAccount.t()}</Linkable>
		</Stack>
	);
};